export type BlogCategory = 'LEARNING' | 'PRIVATE_EQUITY' | 'MARKET_NEWS'
export type BlogStatus = 'DRAFT' | 'PUBLISHED' | 'ARCHIVED'

export const BLOG_CATEGORIES: Readonly<{ text: string; value: BlogCategory; default?: boolean }[]> =
  [
    { text: 'Learning', value: 'LEARNING' },
    { text: 'Private Equity', value: 'PRIVATE_EQUITY' },
    { text: 'Market News', value: 'MARKET_NEWS', default: true },
  ] as const

export const BLOG_STATUSES: Readonly<{ text: string; value: BlogStatus; default?: boolean }[]> = [
  { text: 'Draft', value: 'DRAFT', default: true },
  { text: 'Published', value: 'PUBLISHED' },
  { text: 'Archived', value: 'ARCHIVED' },
] as const
